import React from 'react';
import Cookies from 'js-cookie';
import { useHistory } from 'react-router-dom';
import {
  Grid,
  Typography
} from '@material-ui/core';
import logoImage from './images/DermPro-Logo-white.svg';
import mainPicture from './images/laptop+mobile.png';
import backShadow from './images/Back.svg';


interface ILoginLayout {
  children: JSX.Element,
  title?: string,
  subtitle?: string,
}

export default function LoginLayout({children, title, subtitle}: ILoginLayout) {
  const history = useHistory();
  const isLoggedIn = Cookies.get('token');

  if (isLoggedIn) {
    history.push('/');
  }

  return (
    <Grid container spacing={0} className="min-h-full-screen h-full">
      <Grid item xs={12} md={7} className="bg-primary flex-column items-center justify-center py-20">
        <img
          src={logoImage}
          alt="DermPro"
          className="mb-25 pb-10"
        />
        <div className="relative max-w-500 mt-10 px-4" style={{zIndex: 0}}>
          <img
            src={backShadow}
            alt="Shadow"
            className="absolute"
            style={{left: '50%', top: '-40px', right: '50%', zIndex: '-1', transform: 'translate(-50%, 0)', width: '60%'}}
          />
          <img
            src={mainPicture}
            alt="DermPro Stores"
            className="max-w-full"
          />
        </div>
        <div className="max-w-500 mb-20 px-4">
          <Typography component="h1" className="h1 text-white font-bold text-center">{title}</Typography>
          <Typography variant="h6" className="text-20 text-white font-normal text-center">{subtitle}</Typography>
        </div>
      </Grid>
      <Grid item xs={12} md={5} className="bg-white flex-column items-center justify-center">
        {children}
      </Grid>
    </Grid>
  );
}
